/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */
require('core-js/features/object/assign')

try {
    window.$ = window.jQuery = require('jquery');
} catch (e) {}

require('select2/dist/js/select2.min');
require('jquery-validation/dist/jquery.validate');
require('jquery-validation/dist/additional-methods');
require('inputmask/dist/jquery.inputmask');
require('jquery-mask-plugin/dist/jquery.mask.min');
require('imask');

require('./jquery.bind-first');
require('jquery.scrollto/jquery.scrollTo.min');
require('slick-carousel/slick/slick.min');
window.toastr = require('toastr');

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
        'Accept': 'application/json'
    }
});
